import { BuilderConfig } from '@components/Chat/BuilderConfig';
import { BaseMessage } from '@utilities/ChannelMessaging/BaseMessage.type';

export type MessageEventData = {
	message?: string;
}

export enum ChatMessageType {
	CHAT_CONFIGURATION_SET = 'CHAT:CONFIGURATION:SET',
	CHAT_AUTHENTICATION_SET = 'CHAT:AUTHENTICATION:SET',
	CHAT_NOTIFICATION_SET = 'CHAT:NOTIFICATION:SET',
	CHAT_UNREAD_SET = 'CHAT:UNREAD:SET',
	CHAT_HANDSHAKE_INIT_MESSAGE = 'CHAT:HANDSHAKE:INIT',
	CHAT_HANDSHAKE_RESPONSE_MESSAGE = 'CHAT:HANDSHAKE:READY',
	CHAT_PORT_MESSAGE = 'CHAT:PORT:SEND'
}

export type ChatCount = number;

export type ChatUnreadPayload = {
	count: ChatCount;
	playSound?: boolean;
};

type BuilderConfigPayload = BuilderConfig
export interface BuilderConfigEventData extends Partial<BaseMessage<ChatMessageType.CHAT_CONFIGURATION_SET, BuilderConfigPayload>> {
	version: number;
	payload: BuilderConfigPayload;
}

type AuthTokenPayload = {
	token: string;
}
export interface AuthTokenEventData extends Partial<BaseMessage<ChatMessageType.CHAT_AUTHENTICATION_SET, AuthTokenPayload>>  {
	version: number;
	payload: AuthTokenPayload;
}

type NotificationPayload = {
	token: string;
}

export interface NotificationEventData extends Partial<BaseMessage<ChatMessageType.CHAT_NOTIFICATION_SET, NotificationPayload>> {
	version: number;
	payload: NotificationPayload;
}

export type ChatMessagePayloadMap = {
	[ChatMessageType.CHAT_CONFIGURATION_SET]: BuilderConfigPayload;
	[ChatMessageType.CHAT_AUTHENTICATION_SET]: AuthTokenPayload;
	[ChatMessageType.CHAT_UNREAD_SET]: ChatUnreadPayload;
	[ChatMessageType.CHAT_NOTIFICATION_SET]: NotificationPayload;
};
